import { SnackbarProvider } from 'notistack';
import PortalManager from './components/PortalManager.tsx';
import ClientManager from './components/ClientManager.tsx';
import ItemCommentsManager from './components/ItemCommentsManager.tsx';
import AdminView from './components/AdminView.tsx';
import { mondayClient } from './services/monday';
import { ErrorBox } from '@gorilla/ui/src/components/ErrorBox';
import { ErrorBoundary } from 'react-error-boundary';

import './App.css';

const queryParameters = new URLSearchParams(window.location.search);
const app = queryParameters.get('app');

function App() {
  let content: any = null;

  if (app === 'portal-manager') {
    content = (
      <>
        <SnackbarProvider />
        <PortalManager />
      </>
    );
  }

  if (app === 'client-manager') {
    content = (
      <>
        <SnackbarProvider />
        <ClientManager />
      </>
    );
  }

  if (app === 'item-comments-manager') {
    content = (
      <>
        <SnackbarProvider />
        <ItemCommentsManager />
      </>
    );
  }

  if (app === 'admin') {
    content = (
      <>
        <SnackbarProvider />
        <AdminView />
      </>
    );
  }

  if (content) {
    return <ErrorBoundary fallbackRender={({ error }) => <ErrorBox mondayClient={mondayClient} error={error} />}>{content}</ErrorBoundary>;
  }

  return <div>Unknown view...</div>;
}

export default App;
